// extracted by mini-css-extract-plugin
export default {"menu":"index_menu_THTWX","menu_w1000":"index_menu_w1000_H7VBT","logo":"index_logo_0miwU","menu_r":"index_menu_r_mOtrD","active":"index_active_lPErK"};